import { createSlice } from "@reduxjs/toolkit";
import { Timezones } from "../../dto/ProfileSettings";

const initialState: Timezones = "JST";

const timezoneSlice = createSlice({
  name: "settings/timezone",
  initialState: initialState,
  reducers: {
    setTimezone: (state, { payload }) => {
      return payload;
    },
  },
});

export const { setTimezone } = timezoneSlice.actions;

export default timezoneSlice.reducer;
